export default __webpack_public_path__ + "static/media/SAL1.66a94549.jpg";